import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import { Col, Row } from 'antd';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import { useNavigate } from 'react-router-dom';
import useLocalization from '../../../Localization';

const FaqComponent = () => {
  const navigate = useNavigate();
  const { ApplicationString } = useLocalization();
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['faqComponent.title']}
            subTitle={ApplicationString['pbss.generalInformation.subtitle']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <CustomCollapse titleHide />
          </SectionLayout>
          <SectionLayout>
            <div className='faq-section-contact-us chapter-margin'>
              <p className='chapter-heading-underline'>
                {ApplicationString['faqComponent.contactUs']}
              </p>
            </div>
            <span className='faq-contact-us-content'>
              <a onClick={() => navigate('/contactUs')} target='_blank'>
                {ApplicationString['faqComponent.contactUs.link']}{' '}
              </a>{' '}
              {ApplicationString['faqComponent.contactUs.or']}{' '}
              <a href='mailto:info@pbss.org'>
                {ApplicationString['faqComponent.contactUs.email']}
              </a>
            </span>
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default FaqComponent;
